export default class tccf7HoneyPot {
  constructor( args ) {
    this.base           = args.base;
    this.btn            = args.class.btn;
    this.status         = args.status;

    this.elem           = this.base.elem;
    this.form           = this.base.form;
    this.error          = this.base.error;

    this.errorClass     = args.class.error.pot;

    this.confirmBtn     = this.btn.confirm;
    this.inputmBtn      = this.btn.back;
    this.honeyClass     = '.wpcf7-top_secret';
    this.honeyElem      = this.elem.querySelector(this.honeyClass) || null;
    this.honeyPotValue  = false;

    this.sendCheck      = this.status.send.honey;
    this.start          = false;

    this.initHoneyPot();
  }

  initHoneyPot() {
    if(this.honeyElem === null){
      return;
    }
    this.start = true;
    this.form?.addEventListener('input', this.checkHoneyPot.bind(this));
  }
  checkHoneyPot() {
    if(this.honeyElem.value !== '') {
      console.log('%c☢　入力不可項目で入力を検知しました[tccf7エラー]',this.error);
      this.sendCheck = false;
      this.form.classList.add(this.errorClass);
      this.elem.querySelector(this.confirmBtn)?.setAttribute('disabled', 'true');
      this.elem.querySelector(this.inputmBtn)?.setAttribute('disabled', 'true');
    }else {
      this.sendCheck = true;
      this.form.classList.remove(this.errorClass)
      this.elem.querySelector(this.confirmBtn)?.removeAttribute('disabled');
      this.elem.querySelector(this.inputmBtn)?.removeAttribute('disabled');
    }
  }
}
